import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { motion } from "framer-motion";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ContactForm from "../../components/ContactForm";
import CTAButton from "../../components/CTAButton";
import SEO from "../../components/SEO";

const EventCleaning = () => {
  return (
    <>
      <SEO
        title="Event Cleaning Services Management | Pre, On-site & Post Event Cleaning"
        description="Comprehensive event cleaning management: pre-event deep cleaning, on-site trash removal and restroom maintenance, and post-event deep cleaning to restore venues. Flexible scheduling and emergency response."
        keywords="event cleaning, event cleaning management, pre-event cleaning, post-event cleaning, on-site trash removal, restroom maintenance, venue cleaning"
        url="https://blossomcleaningservices.com/services/event-cleaning"
      />
      <Header />

      <Box
        sx={{
          position: "relative",
          py: 12,
          backgroundImage:
            "url(https://images.unsplash.com/photo-1505765050634-6c1f8f7f7f2d?w=1920&q=80)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(34, 51, 95, 0.65)",
          },
        }}
      >
        <Container sx={{ position: "relative", zIndex: 1 }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              variant="h1"
              sx={{
                mb: 3,
                color: "white",
                fontSize: { xs: "2rem", md: "3rem" },
              }}
            >
              Event Cleaning Services Management
            </Typography>
            <Typography
              variant="h5"
              sx={{ maxWidth: 800, color: "rgba(255,255,255,0.95)", mb: 4 }}
            >
              Planning and executing cleaning for events — pre-event deep
              cleaning, on-site maintenance, and post-event restoration to keep
              venues safe and professional.
            </Typography>
            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
              <CTAButton to="/contact">Book Event Cleaning</CTAButton>
              <CTAButton
                href="tel:0752058190"
                variant="outlined"
                sx={{ color: "white", borderColor: "white" }}
              >
                Call 0752 058 190
              </CTAButton>
            </Box>
          </motion.div>
        </Container>
      </Box>

      <Box sx={{ py: 8 }}>
        <Container>
          <Grid container spacing={6}>
            <Grid item xs={12} md={8}>
              <Typography variant="h3" sx={{ mb: 3, fontWeight: 600 }}>
                What We Do
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
                Event cleaning services management involves planning,
                coordinating, and executing cleaning tasks before, during, and
                after an event to ensure a safe, clean, and professional
                environment. Our teams handle pre-event deep cleaning, on-site
                trash removal, restroom servicing, and post-event restoration so
                venues are ready and compliant.
              </Typography>

              <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>
                Key Services
              </Typography>
              <ul>
                <li>Pre-event deep cleaning and sanitization</li>
                <li>On-site trash removal and collection</li>
                <li>Continuous restroom maintenance during events</li>
                <li>Post-event deep cleaning and venue restoration</li>
                <li>Flexible scheduling and rapid response for emergencies</li>
              </ul>

              <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
                We tailor staffing and schedules to each event, from small
                gatherings to large conferences and festivals. Our focus is on
                attention to detail, minimizing disruption, and ensuring the
                venue is returned to its original condition.
              </Typography>
            </Grid>

            <Grid item xs={12} md={4}>
              <Card sx={{ mb: 4, p: 3 }}>
                <CardContent>
                  <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                    Quick Quote
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 3 }}>
                    Get a tailored event cleaning plan and quote.
                  </Typography>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    <CTAButton href="tel:0752058190" variant="contained">
                      📞 Call Now
                    </CTAButton>
                    <CTAButton to="/contact" variant="outlined">
                      Request Quote Online
                    </CTAButton>
                  </Box>
                </CardContent>
              </Card>

              <Box
                component="img"
                src="https://images.unsplash.com/photo-1545239351-1141bd82e8a6?w=800&q=80"
                alt="Event cleaning"
                sx={{ width: "100%", borderRadius: 2, boxShadow: 3 }}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box sx={{ py: 8, backgroundColor: "background.paper" }}>
        <Container maxWidth="md">
          <ContactForm
            title="Request Event Cleaning Quote"
            showServiceSelect={false}
          />
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default EventCleaning;
